import { SecurityRuleFactory, createSimpleClaimRule } from "../auth-rules";

export type IsViewerClaimType = string | string[];
export type IsViewerClaimArgs = {};

export const ruleIsViewer: SecurityRuleFactory<IsViewerClaimType, IsViewerClaimArgs> =
  createSimpleClaimRule<IsViewerClaimType, IsViewerClaimArgs>("viewer");

